export const GET_PROERTY_BANK_VERIFY_LISTS = '[Property Bank Verify Action] Get property bank verify list';
export const CONFIRMED_GET_PROERTY_BANK_VERIFY_LISTS = '[Property Bank Verify Action] Confirmed Get property bank verify list';
export const GET_PROERTY_BANK_VERIFY_MESSAGES = '[Property Bank Verify Action] Get property bank message list';
export const CONFIRMED_GET_PROERTY_BANK_VERIFY_MESSAGES = '[Property Bank Verify Action] Confirmed Get property bank message list';
